import React from 'react';

import kebabCase from 'lodash/kebabCase';

import { Button, Text } from '@change/ds-core-ui/next';
import { Checkbox } from '@change/ds-forms/next';

import type { TaskShape } from '../../../../types';

// TODO: might need to clean up props type for icon
type CompletedTaskProps = Omit<TaskShape, 'status' | 'isFirstActive'>;
export function CompletedTask({
	name,
	title,
	description,
	primaryActionText,
	primaryActionHref,
	primaryActionOnClick,
}: CompletedTaskProps): React.JSX.Element {
	return (
		<div>
			<div data-qa="petition-task" className="flex flex-col justify-between gap-4 py-5 md:flex-row md:gap-5">
				<div className="[&_[data-rac]_div:first-of-type]:!bg-fill-selected flex items-start md:items-center [&_[data-rac]]:!gap-4 md:[&_[data-rac]]:!gap-5 [&_[data-rac]_div:first-of-type]:h-6 [&_[data-rac]_div:first-of-type]:w-6 [&_[data-rac]_div:first-of-type]:rounded-small md:[&_[data-rac]_div:first-of-type]:self-center [&_[data-rac]_div:first-of-type_svg]:mx-auto [&_[data-rac]_div:first-of-type_svg]:h-5 [&_[data-rac]_div:first-of-type_svg]:w-5">
					<Checkbox name={`task-checkbox-${kebabCase(name)}`} isSelected isReadOnly isDisabled>
						<Text
							data-qa={`task-title-${kebabCase(name)}`}
							variant="body"
							className="text-typography-weak text-size-body-bold line-through"
							as="p"
						>
							{title}
						</Text>
						<Text
							data-qa={`task-description-${kebabCase(name)}`}
							variant="body"
							size="small"
							className="text-typography-weak line-through"
							as="p"
						>
							{description}
						</Text>
					</Checkbox>
				</div>
				<div className="hidden flex-col items-start gap-6 opacity-0 transition-opacity duration-200 group-hover:flex group-hover:opacity-100 md:flex-row md:items-center">
					{primaryActionHref ? (
						<Button
							as="a"
							variant="secondary"
							size="x-small"
							href={primaryActionHref}
							onClick={primaryActionOnClick}
							data-qa={`task-action-button-${kebabCase(name)}`}
							className="bg-fill-inverse-strong w-full md:w-40"
						>
							{primaryActionText}
						</Button>
					) : (
						<Button
							variant="secondary"
							size="x-small"
							onClick={primaryActionOnClick}
							data-qa={`task-action-button-${kebabCase(name)}`}
							className="bg-fill-inverse-strong w-full md:w-40"
						>
							{primaryActionText}
						</Button>
					)}
				</div>
			</div>
		</div>
	);
}
